module.exports = __webpack_public_path__ + "static/media/sliderLeftArrow.49d9e514.svg";